<template>
  <div class="about__scheme" id="karta-etazhey" v-if="loaded">
    <h4 class="subtitle">НАВИГАЦИЯ</h4>
    <h2 class="title-1 about__scheme-title">Карта Торгового Центра</h2>

    <select class="form-control about__scheme-control" v-model="stage">
      <option value="1">1 этаж</option>
      <option value="2">2 этаж</option>
      <option value="3">3 этаж</option>
      <option value="4">4 этаж</option>
    </select>

    <div class="about__scheme-img">
      <Stage1 v-if="stage == 1" :values="values" @showShop="showShop"/>
      <Stage2 v-if="stage == 2" :values="values" @showShop="showShop"/>
      <Stage3 v-if="stage == 3" :values="values" @showShop="showShop"/>
      <Stage4 v-if="stage == 4" :values="values" @showShop="showShop"/>

      <div v-for="st in [1,2,3,4]" v-if="stage == st && values.shops_by_stages[st]">
        <div v-for="shop in values.shops_by_stages[st]" v-if="showKey == '' + shop.stage + '-' + shop.place.name">
          <figure class="map__tooltip" v-if="popup === 1">
            <div class="map__tooltip-inner">
              <a class="map__close" href="" @click.prevent="popup = 0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.8299 9.17004L9.16992 14.83" stroke="#323232" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M14.8299 14.83L9.16992 9.17004" stroke="#323232" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
                        stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
              <div class="map__tooltip-img">
                <img :src="shop.logo_image" v-if="shop.logo_image" width="126" style="display: block;"/>
              </div>
              <figcaption class="map__tooltip-caption">
                <h3 class="map__tooltip-title">{{ shop.name }}</h3>
                <div class="map__tooltip-details" v-html="shop.map_tooltip">{{ shop.map_tooltip }}</div>
                <div class="map__tooltip-tags">
                  <!-- @todo: правильную ссылку на фильтрацию с выбранной категорией -->
                  <a v-for="shop_type in shop.shop_types" :href="'/shop?shop_type=' + shop_type.short "
                     class="map__tooltip-tag">{{ shop_type.name }}</a>
                </div>
                <div class="map__tooltip-contacts">
                  <div class="map__tooltip-link map__tooltip-link--phone">{{ shop.shop_phone }}</div>
                  <a class="map__tooltip-link map__tooltip-link--url" :href="shop.shop_url"
                     v-if="shop.shop_url">{{ shop.shop_url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1] }}</a>
                </div>
              </figcaption>
            </div>
            <a :href="shop.link" v-if="shop.link" class="btn btn--outline arrow-btn map__tooltip-btn">Страница
              магазина</a>
          </figure>
        </div>
        <!--
        <button class="btn" v-for="shop in values.shops_by_stages[st]"
                @click="showShop(st, shop.place.name)">
          {{ shop.name }} {{ st }}-{{ shop.place.name }}
        </button>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import Stage1 from 'stages/stage1';
import Stage2 from 'stages/stage2';
import Stage3 from 'stages/stage3';
import Stage4 from 'stages/stage4';

export default {
  components: {
    Stage1, Stage2, Stage3, Stage4
  },
  props: ['data-values'],
  data: function () {
    return {
      popup: 0,
      stage: 1,
      showKey: '',
      values: {shops_by_stages: {}},
      loaded: false,
      __last__: false
    }
    // @todo: stage=3&place=3d04&line=d
  },
  mounted() {
    this.values = JSON.parse(this.dataValues);
    this.loaded = true;
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let stage = params.get('stage');
    let place_name = params.get('place');

    if (stage !== null) {
      this.stage = parseInt(stage, 10);
    }
    if (stage !== null && place_name !== null && this.isShop(stage, place_name)) {
      this.showShop(stage, place_name);
    }
  },
  methods: {
    showShop: function (stage_name, place_name) {
      this.showKey = '' + stage_name + '-' + place_name;
      this.popup = 1;
    }
  }
}
</script>
